let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e56oM")).then(() => parcelRequire('f4OSv'));